import { useFeedback } from "@/context/FeedbackContext";

export default function SiteFooter() {
  const { openFeedback } = useFeedback();
  return (
    <footer className="border-t border-[#E8E3D9] bg-[#F5F2EA] mt-8" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-6 lg:px-8 py-6 flex flex-col items-center gap-2 text-center text-sm text-[#6E6860]">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-x-2 gap-y-1">
          <span>
            <span className="font-medium text-[#2D2A26]">Between Us is in active development.</span>{" "}
            We're actively seeking your feedback on how to make it better —
          </span>
          <button
            onClick={openFeedback}
            data-testid="footer-feedback-link"
            className="text-[#4A5D4E] font-medium underline underline-offset-4 hover:text-[#3B4A3E] transition-colors"
          >
            please help us improve!
          </button>
        </div>
        <p className="text-[#A39E94]">
          A project of{" "}
          <a
            href="https://www.commongroundinstitute.net"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-cgi-link"
            className="text-[#4A5D4E] font-medium underline underline-offset-4 hover:text-[#3B4A3E] transition-colors"
          >
            Common Ground Institute
          </a>
        </p>
      </div>
    </footer>
  );
}
